import React from 'react';
import classNames from 'classnames';
// model
import VacancyInterface from '../../../../model/Vacancy';
// common components
import ApplyForm from '../../../../common/components/ApplyForm/ApplyForm';
// local components
// styles
import './MobileFormBlock.css';

interface Props {
  text: string | JSX.Element,
  vacancy?: VacancyInterface,
  className?: string;
}

class MobileFormBlock extends React.Component<Props> {
  
  render(): JSX.Element {
    const { text, vacancy, className } = this.props;
    const currentClass: {[key: string]: boolean} = {
      "apply-to-vacancy": true,
    };
    if (className) currentClass[className] = true;
    
    return (
      <div className={classNames(currentClass)}>
        <div className="hr-mission">
          <div className="container">
            <div className="mobile-visible tablet-visible hidden">
              <div className="hr-mission-inner">
                { text }
              </div>
            </div>
          </div>
        </div>
        <div className="content">
          <div className="container">
            <div className="content-inner">
              <ApplyForm id="vacancy-apply-form" vacancy={vacancy} key={`referal-form-$[windowWidth]`} />
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default MobileFormBlock;
